// extracted by mini-css-extract-plugin
module.exports = {"favorite":"FavoriteButton_favorite__ygGZo","loading":"FavoriteButton_loading__p5AID","signIn":"FavoriteButton_signIn__I0wxW"};